export default __webpack_public_path__ + "media/images/react_icons/property/pool-d8ece137e708322bb8eecdc47654574a.svg";